var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// saml-client/api/resolver.ts
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { registerQuery } from "@adornis/baseql/metadata/register.js";
import { resolveGetIdPList } from "../server/server.js";
var IdPSelectionListEntry = class extends AdornisEntity {
};
IdPSelectionListEntry._class = "IdPSelectionListEntry";
__decorateClass([
  Field((type) => String)
], IdPSelectionListEntry.prototype, "_id", 2);
__decorateClass([
  Field((type) => String)
], IdPSelectionListEntry.prototype, "entityID", 2);
__decorateClass([
  Field((type) => String)
], IdPSelectionListEntry.prototype, "displayName", 2);
IdPSelectionListEntry = __decorateClass([
  Entity()
], IdPSelectionListEntry);
var getIdPList = registerQuery({
  operationName: "getIdPList",
  resolve: resolveGetIdPList,
  type: () => [IdPSelectionListEntry]
});
export {
  IdPSelectionListEntry,
  getIdPList
};
